import cn from 'classnames';
import React from 'react';

import styles from './PaymentOptionsList.css';

interface Props {
  children: React.ReactNode;
  list?: boolean;
}

export const PaymentOptionsList = ({ children, list }: Props) => {
  const options = React.Children.toArray(children);

  return (
    <div
      className={cn(styles.PaymentOptionsList, {
        [styles.PaymentOptionsList_list]: list,
      })}
    >
      {options.map((option, index) => (
        <React.Fragment
          key={
            React.isValidElement(option) && option.key != null
              ? option.key
              : index
          }
        >
          {list && index > 0 && (
            <div
              className={styles.PaymentOptionsList__Divider}
              data-test="payment-options-divider"
              aria-hidden="true"
            />
          )}
          {option}
        </React.Fragment>
      ))}
    </div>
  );
};
